import loadable from '@loadable/component';
import Loading from '../../components/Loading';

export default loadable(() => import('./DeveloperTools'), { fallback: Loading });
